import { SupportedLinkPreview } from './types';

const YOUTUBE_HOSTS = new Set([
  'm.youtube.com',
  'music.youtube.com',
  'youtu.be',
  'youtube.com',
]);

const stripFragment = (value: URL): string => {
  const normalizedUrl = new URL(value.toString());
  normalizedUrl.hash = '';
  return normalizedUrl.toString();
};

export const buildYouTubePreview = (url: string): SupportedLinkPreview | null => {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.replace(/^www\./i, '').toLowerCase();

    if (!YOUTUBE_HOSTS.has(hostname)) {
      return null;
    }

    const pathSegments = parsedUrl.pathname.split('/').filter(Boolean);
    let canonicalUrl = '';
    let meta = '';
    let resourceType: SupportedLinkPreview['resourceType'] | null = null;
    let subtitle = '';
    let title = '';

    if (hostname === 'youtu.be' && pathSegments[0]) {
      canonicalUrl = `https://www.youtube.com/watch?v=${pathSegments[0]}`;
      meta = 'Video';
      resourceType = 'video';
      subtitle = 'Watch on YouTube';
      title = 'YouTube Video';
    } else if (pathSegments[0] === 'watch') {
      const playlistId = parsedUrl.searchParams.get('list');
      if (playlistId) {
        canonicalUrl = `https://www.youtube.com/playlist?list=${playlistId}`;
        meta = 'Playlist';
        resourceType = 'playlist';
        subtitle = 'Open on YouTube';
        title = 'YouTube Playlist';
      } else {
        const videoId = parsedUrl.searchParams.get('v');
        if (!videoId) {
          return null;
        }
        canonicalUrl = `https://www.youtube.com/watch?v=${videoId}`;
        meta = 'Video';
        resourceType = 'video';
        subtitle = 'Watch on YouTube';
        title = 'YouTube Video';
      }
    } else if (['embed', 'live', 'shorts'].includes(pathSegments[0]) && pathSegments[1]) {
      canonicalUrl = `https://www.youtube.com/watch?v=${pathSegments[1]}`;
      meta = 'Video';
      resourceType = 'video';
      subtitle = 'Watch on YouTube';
      title = 'YouTube Video';
    } else if (pathSegments[0] === 'playlist') {
      const playlistId = parsedUrl.searchParams.get('list');
      if (!playlistId) {
        return null;
      }
      canonicalUrl = `https://www.youtube.com/playlist?list=${playlistId}`;
      meta = 'Playlist';
      resourceType = 'playlist';
      subtitle = 'Open on YouTube';
      title = 'YouTube Playlist';
    }

    if (!canonicalUrl || !resourceType) {
      return null;
    }

    return {
      ariaLabel: `Open ${title} on YouTube`,
      artworkUrl: '',
      canonicalUrl: stripFragment(new URL(canonicalUrl)),
      eyebrow: 'YouTube',
      meta,
      provider: 'youtube',
      resourceType,
      subtitle,
      title,
    };
  } catch (error) {
    return null;
  }
};
